import { render, staticRenderFns } from "./TopFiveActiveResource.vue?vue&type=template&id=6da7ccd1&scoped=true"
import script from "./TopFiveActiveResource.vue?vue&type=script&lang=js"
export * from "./TopFiveActiveResource.vue?vue&type=script&lang=js"
import style0 from "./TopFiveActiveResource.vue?vue&type=style&index=0&id=6da7ccd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da7ccd1",
  null
  
)

export default component.exports